// extracted by mini-css-extract-plugin
export default {"spinner-content":"AdditionalContactTab_spinner-content__qOlbQ","spinner":"AdditionalContactTab_spinner__ho6+a"};